module.exports = __webpack_public_path__ + "static/media/mulher_r2_c5.5f989104.jpg";